import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./components/HomePage";

function App() {

  useEffect(() => {
    const badge = document.getElementById("emergent-badge");
    if (badge) badge.remove();
 }, []);

  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
      </div>
    </LanguageProvider>
  );
}

export default App